import {
    useMemo,
} from 'react'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import {
    LoggerType,
} from 'app/enums/label.enums'
import Label from 'app/shared-components/Label'

import getReadingThresholdType, {
    ReadingThresholdType,
} from 'app/utils/getReadingThresholdType'
import Age from './Age'

import useStyles from './TemperatureAge.style'

type Props = {
    value?: string
    title?: string
    rowProps: {
        loggerType?: LoggerType
    }
}

const TemperatureAge = ({
    value,
    title = '',
    rowProps,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const readingType = useMemo(() => {
        return getReadingThresholdType(value)
    }, [value])

    const icon = useMemo(() => {
        if (value) {
            return readingType === ReadingThresholdType.LIVE ? (
                <CloudDoneIcon
                    className={classes.cloudIcon}
                    data-testid="icon-cloud-done"
                />
            ) : (
                <CloudOffIcon
                    className={classes.cloudOffIcon}
                    data-testid="icon-cloud-off"
                />
            )
        }

        return null
    }, [
        readingType,
        classes,
        value,
    ])

    return (
        <div>
            {title && (
                <Label
                    title={title}
                />
            )}
            <div className={classes.wrapper}>
                <div
                    className={title ? classes.iconWrapperWithLabel : classes.iconWrapper}
                >
                    {icon}
                </div>
                <Age
                    value={value}
                    className={title ? classes.text : undefined}
                    specialColorCodingProperty={rowProps?.loggerType}
                />
            </div>
        </div>
    )
}

export default TemperatureAge
